<template lang="pug">
#map.absolute.absolute--fill
</template>

<script>
import mapboxgl from 'mapbox-gl';
import U from 'mapbox-gl-utils';
import { EventBus } from '../EventBus';
import { debounce } from 'debounce';
function pointLayer(name, filter, options) {}

const rasterLayersByTeam = {
    10: 'Ag,Au,Co,Cu,Fe,Mn,Ni,U,Zn'.split(','),

    41: 'Ag,Au,Co,Fe,Mn,Ni,U,Zn'.split(','),
    // As,Bi,Ca,Mo,P,Pb,S,

    // IOCG = 'Au,U,Cu' // not Fe I think
    30: ['Au', 'U', 'Cu']
};
const sources = {
    local: {
        points: 'http://localhost:4010/points/index.json',
        polygons: 'http://localhost:4010/polygons/index.json',
        raster: id => `http://localhost:4010/${id}/index.json`
    },
    mapbox: {
        points: 'mapbox://unearthed-solutions.points',
        polygons: 'mapbox://unearthed-solutions.polygons',
        raster: id => `mapbox://unearthed-solutions.${id}`
    }
}[
    (window.location.hash || '').match(/mapbox/) ||
    window.location.hostname !== 'localhost'
        ? 'mapbox'
        : 'local'
];

export default {
    data: () => ({
        teamFilter: true,
        selectedMinerals: {},
        selectedId: undefined,
        mapLoaded: false,
        checkedTeams: {}
    }),
    props: ['minerals'],
    async mounted() {
        mapboxgl.accessToken =
            'pk.eyJ1IjoidW5lYXJ0aGVkLXNvbHV0aW9ucyIsImEiOiJja2YzY3h4dXcwMXpuMnZsc3VlNWdpM3I1In0.Oe0WSGV5FNoIMVQyGEljUw' ||
            (window.location.hash || '').match(/accessToken=(pk.*4w)/)[1];

        const map = new mapboxgl.Map({
            container: 'map',
            center: [134, -30],
            zoom: 6,
            style:
                'mapbox://styles/unearthed-solutions/ckf3ctwen0k0919s3td1b3b4v',
            hash: 'loc',
            minZoom: 5
        });
        U.init(map, mapboxgl);
        map.U.onLoad(() => (this.mapLoaded = true));
        window.map = map;
        window.app.Map = this;
        this.map = map;
        map.U.onLoad(() => {
            EventBus.$emit('map-loaded');
            this.addRasterLayers();
            map.U.addVector('points', sources.points);
            map.U.addVector('polygons', sources.polygons);
            const circleRadius = [
                'interpolate',
                ['linear'],
                ['zoom'],
                5,
                1.5, //1
                7,
                3,
                13,
                6
            ];

            for (const commodity of this.shownMinerals) {
                map.U.addFill(
                    `polygons-${commodity}`,
                    'polygons',
                    {
                        sourceLayer: 'polygons',
                        fillColor: this.minerals[commodity].color,
                        filter: this.polygonFilter(commodity),
                        fillOpacity: 0.4,
                        // fillOutlineColor: 'transparent',
                        fillOutlineColor: [
                            'case',
                            ['to-boolean', ['feature-state', 'hover']],
                            'blue',
                            'transparent'
                        ],

                        visibility: this.selectedMinerals[commodity]
                            ? 'visible'
                            : 'none'
                    },
                    'waterway-label'
                );
                map.U.addCircle(
                    `points-${commodity}`,
                    'points',
                    {
                        sourceLayer: 'points',
                        circleColor: this.minerals[commodity].color,
                        circleRadius,
                        filter: this.pointFilter(commodity),
                        circleOpacity: [
                            'interpolate',
                            ['linear'],
                            ['zoom'],
                            5,
                            0.8,
                            8,
                            1
                        ],
                        circleBlur: [
                            'interpolate',
                            ['linear'],
                            ['zoom'],
                            5,
                            0,
                            8,
                            1
                        ],
                        visibility: this.selectedMinerals[commodity]
                            ? 'visible'
                            : 'none'
                    },
                    'waterway-label'
                );
            }
            const commodityLayers = [
                'points-other',
                ...this.shownMinerals.map(commodity => `points-${commodity}`),
                ...this.shownMinerals.map(commodity => `polygons-${commodity}`)
            ];

            const blurColor = 'hsl(30,100%,50%)';
            map.U.addLine(`selected-line-blur`, 'polygons', {
                sourceLayer: 'polygons',
                lineColor: [
                    'case',
                    ['to-boolean', ['feature-state', 'selected']],
                    blurColor,
                    ['to-boolean', ['feature-state', 'hover']],
                    blurColor,
                    'transparent'
                ],
                lineWidth: [
                    'case',
                    ['to-boolean', ['feature-state', 'selected']],
                    7,
                    ['to-boolean', ['feature-state', 'hover']],
                    5,
                    0
                ],
                lineBlur: 3,
                lineJoin: 'round',
                lineCap: 'round'
            });
            map.U.addLine(`selected-line`, 'polygons', {
                sourceLayer: 'polygons',
                lineColor: [
                    'case',
                    ['to-boolean', ['feature-state', 'selected']],
                    'white',
                    'transparent'
                ],
                lineWidth: 2,
                lineJoin: 'round',
                lineCap: 'round'
            });
            map.U.addCircle(`selected-circle-blur`, 'points', {
                sourceLayer: 'points',
                circleColor: 'transparent',
                circleRadius: 12,
                circleStrokeColor: [
                    'case',
                    ['to-boolean', ['feature-state', 'selected']],
                    blurColor,
                    'transparent'
                ],
                circleStrokeOpacity: 0.7,
                circleStrokeWidth: 7
                // circleBlur: 3
            });
            map.U.addCircle(`selected-circle`, 'points', {
                sourceLayer: 'points',
                circleColor: 'transparent',
                circleRadius: 14,
                circleStrokeColor: [
                    'case',
                    ['to-boolean', ['feature-state', 'selected']],
                    'white',
                    'transparent'
                ],
                circleStrokeWidth: 3
            });

            // const rasterLayers = ['10-ag', '41-ag', '30-iocg'];

            // const rasterLayers = ['30-iocg'];
            // for (const rasterId of rasterLayers) {
            //     map.addSource(rasterId, {
            //         type: 'raster',
            //         url: `http://localhost:4010/${rasterId}/index.json`
            //     });
            //     map.U.addLayer(rasterId, rasterId, {
            //         type: 'raster',
            //         rasterOpacity: 1
            //     });
            // }

            map.U.hoverPointer(commodityLayers);
            map.U.clickOneLayer([...commodityLayers /*'selected-line'*/], e => {
                window.log(e.feature.properties);
                this.clearSelection();
                EventBus.$emit('select-feature', e.features[0]);
                map.setFeatureState(e.feature, { selected: true });
            });
            map.U.hoverFeatureState(commodityLayers);
        });
        EventBus.$on('team-filter', (selectedTeam, checkedTeams) => {
            this.checkedTeams = checkedTeams;
            const teamFilter = [
                'in',
                ['get', 'team'],
                [
                    'literal',
                    Object.keys(checkedTeams)
                        .filter(team => checkedTeams[team])
                        .map(team => +team)
                ]
            ];
            window.log(teamFilter);
            this.teamFilter = teamFilter;
        });
        EventBus.$on('mineral-filter', selected => {
            this.selectedMinerals = selected;
            // this.mineralFilter = mineral ? ['==', ['get', 'mineral'], mineral] : true;
        });
    },
    computed: {
        shownMinerals() {
            return Object.keys(this.minerals).filter(
                m => this.minerals[m].show
            );
        }
    },
    methods: {
        addRasterLayers() {
            for (const team of Object.keys(rasterLayersByTeam)) {
                for (const mineral of rasterLayersByTeam[team]) {
                    const rasterId = `${team}-${mineral}`;
                    this.map.addSource(rasterId, {
                        type: 'raster',
                        url: sources.raster(rasterId.toLowerCase()) //`http://localhost:4010/${rasterId.toLowerCase()}/index.json`
                    });
                    this.map.U.addLayer(rasterId, rasterId, {
                        type: 'raster',
                        rasterOpacity: 1
                    });
                }
            }
        },
        clearSelection() {
            if (this.mapLoaded) {
                this.map.removeFeatureState({
                    source: 'points',
                    sourceLayer: 'points'
                });
                this.map.removeFeatureState({
                    source: 'polygons',
                    sourceLayer: 'polygons'
                });
            }
            EventBus.$emit('select-feature');
        },
        filter(commodity /*, type*/) {
            const filterByTeam = x => ['all', this.teamFilter, x];
            if (commodity === 'other') {
                return filterByTeam(
                    /*
                    Has a commodity but it's not one of the common ones
                    */
                    [
                        'match',
                        ['to-string', ['get', 'commodity']],
                        ['', ...Object.keys(this.minerals)],
                        false,
                        true
                    ]
                );
            } else if (commodity === 'unknown') {
                return filterByTeam(
                    ['!', ['has', 'commodity']],
                    ...Object.keys(this.minerals).map(commodity => [
                        '!',
                        ['has', commodity]
                    ])
                );
            } else {
                return filterByTeam([
                    'any',
                    ['==', ['get', 'commodity'], commodity],
                    ['get', commodity]
                ]);
            }
        },

        pointFilter(commodity) {
            return this.filter(commodity, 'Point');
        },
        polygonFilter(commodity) {
            return this.filter(commodity, 'Polygon'); // TODO multipolygon
        },
        toggleLayers() {
            const toggleRasterLayers = mineral => {
                const onlyOneMineralLayer =
                    Object.values(this.selectedMinerals).filter(Boolean)
                        .length === 1;

                for (const team of Object.keys(rasterLayersByTeam)) {
                    if (rasterLayersByTeam[team].includes(mineral)) {
                        this.map.U.toggle(
                            `${team}-${mineral}`,
                            onlyOneMineralLayer &&
                                this.selectedMinerals[mineral] &&
                                this.checkedTeams[team]
                        );
                    }
                }
            };
            const doToggle = () => {
                this.shownMinerals.forEach(mineral => {
                    this.map.U.toggle(
                        [`points-${mineral}`, `polygons-${mineral}`],
                        this.selectedMinerals[mineral]
                    );
                    window.log(
                        'toggle',
                        [`points-${mineral}`, `polygons-${mineral}`],
                        this.selectedMinerals[mineral]
                    );
                    toggleRasterLayers(mineral);
                });
            };
            debounce(() => {
                if (this.mapLoaded) {
                    doToggle();
                } else {
                    this.map.U.onLoad(doToggle);
                }
            }, 500)();
        },
        updateCommodityFilters() {
            if (this.mapLoaded) {
                for (const commodity of ['other', ...this.shownMinerals]) {
                    this.map.U.setFilter(
                        [`points-${commodity}`, `polygons-${commodity}`],
                        this.filter(commodity)
                    );
                }
            }
        }
    },
    watch: {
        teamFilter() {
            this.updateCommodityFilters();
        },
        checkedTeams: {
            deep: true,
            handler() {
                this.toggleLayers();
                this.clearSelection();
                // this.updateRasterLayers();
            }
        },
        selectedMinerals: {
            deep: true,
            handler() {
                this.toggleLayers();
                this.updateCommodityFilters();
                this.clearSelection();
            }
        }
    }
};
import 'mapbox-gl/dist/mapbox-gl.css';
</script>

<style scoped>
</style>
